<template>
    <div class="login_box">
        <div class="login_box_title">
            登录 | 注册
        </div>
        <div class="form_box">
            <div class="form_box_tabs_div">
                <div :class="[tabsType == 1? 'form_box_tabs_div_item select':'form_box_tabs_div_item']" @click="tabsType = 1">账号登录</div>
                <div :class="[tabsType == 2? 'form_box_tabs_div_item select':'form_box_tabs_div_item']" @click="tabsType = 2">验证码登录</div>
            </div>
            <div class="form_content" v-if="tabsType == 2">
                <el-form label-width="0" :model="formLabelAlign">
                    <el-form-item label="">
                        <el-input v-model="formLabelAlign.username" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input v-model="imgVer" prefix-icon="el-icon-picture-outline" placeholder="请输入图片验证码">
                            <el-button class="yzmbtn" slot="append" @click="changeImage">
                                <img v-if="smsImage != ''" style="height: 26px;vertical-align: middle;" :src="smsImage" alt="">
                                <span v-else>图片验证码</span>
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input v-model="formLabelAlign.smsCode" prefix-icon="el-icon-s-order" placeholder="请输入短信验证码">
                            <el-button class="yzmbtn" slot="append" @click="getYzm()">
                                <template v-if="sending">
                                    获取验证码
                                </template>
                                <template v-else>
                                    {{second}}秒后重发
                                </template> 
                            </el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="form_submit" @click="submit_sms()">登录</div>
            </div>

            <div class="form_content" v-if="tabsType == 1">
                <el-form label-width="0" :model="formLabelAlign2">
                    <el-form-item label="">
                        <el-input v-model="formLabelAlign2.username" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input type="password" v-model="formLabelAlign2.password" prefix-icon="el-icon-tickets" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div class="form_submit" @click="submit_form()">登录</div>
            </div>
            <div class="privacy_notice">
                登录即表示您同意<a @click="goPrivacy()">隐私政策</a>和<a @click="goTerms()">用户协议</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            tabsType:2,
            second:120,
            sending: true,      //是否发送验证码
            disabled: false,   //是否禁发验证码
            imgVer:'',          //图片验证码
            smsImage:'',        //图片验证码图片
            formLabelAlign:{
                username:'',
                smsCode:''
            },
            formLabelAlign2:{
                username:'',
                password:''
            }
        }
    },
    methods:{
        goPrivacy(){
            window.open('https://www.xcc.cn/privacy-policy', '_blank');
        },
        goTerms(){
            window.open('https://www.xcc.cn/terms-of-service', '_blank');
        },
        changeImage(){
            var _this = this;
            var phoneReg = /^[1][0-9][0-9]{9}$/;
            if (!phoneReg.test(this.formLabelAlign.username)) {
                this.$message.error("请输入正确的手机号")
                return
            }
            this.$axios({
                method: 'get',
                url: this.$posh + "api/sms/getImageCode?phone=" + this.formLabelAlign.username
            }).then((res)=>{
                _this.smsImage = res.data;
            })
        },
        getYzm(){
             var _this = this;
            if(!this.sending){
                return
            };
            if (this.imgVer == '') {
                this.$message.error("请填写图片验证码")
                return
            };
            if (this.formLabelAlign.username.length == 11) {
                var url = 'api/sms/sendSms?phone='+this.formLabelAlign.username+'&imgVar='+this.imgVer
                this.getRequest(url).then((res)=>{
                    var data = res.data;
                    if(data.status == 200){
                        _this.sending = false;      //是否发送验证码
                        _this.disabled = true;      //是否禁发验证码
                        _this.countDown();          //倒计时
                    }
                })
            } else {
                this.$message.error("您的账号格式错误")
            }
        },
        countDown(){
            let result = setInterval( ()=>{
                --this.second;
                if(this.second < 0){
                    clearInterval(result);
                    this.sending  = true;
                    this.disabled = false;
                    this.second = 120;
                }
            }, 1000);
        },
        submit_sms(){
            var _this = this;
            this.postParamDun('api/user/phoneLogin',this.formLabelAlign).then((res)=>{
                var data = res.data;
                if (data.status == 200) {
                    console.log(data);
                    window.parent.postMessage({
                        funName:'addStorage',
                        obj:{
                            username:data.obj.username,
                            token:data.obj.jwt
                        }
                    },'*')
                }
            })
        },
        submit_form(){
            var _this = this;
            this.postRequest('api/user/login',this.formLabelAlign2).then((res)=>{
                var data = res.data;
                if (data.status == 200) {
                    console.log(data);
                    window.parent.postMessage({
                        funName:'addStorage',
                        obj:{
                            username:data.obj.username,
                            token:data.obj.jwt
                        }
                    },'*')
                }
            })
        }
    },
    mounted(){

    }
}
</script>
<style lang="scss" scoped>
.login_box{
    width: 100%;
    height: auto;
    background-image: url('https://zyprogram.xinchacha.com/plugin/login_bg_img.png');
    padding-top: 1px;
    padding-bottom: 17px;
    box-sizing: border-box;
}

.login_box_title{
    width: 100%;
    height: 33px;
    color: #F1DFB6;
    font-weight: 500;
    font-size: 24px;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 24px;
}

.form_box{
    width: 92%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.09);
    border-radius: 11px;
    margin: 0 auto;
    padding-bottom: 1px;
    >div.form_box_tabs_div{
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-around;
        >div.form_box_tabs_div_item{
            width: auto;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            font-weight: 500;
            color: #BDBDBD;
        }
        >div.form_box_tabs_div_item.select{
            height: 47px;
            line-height: 47px;
            color: #4685D7;
            border-bottom: 3px solid #4685D7;
        }
    }
    >div.form_content{
        width: 90%;
        height: auto;
        margin: 20px auto;
        >div.form_submit{
            width: 80%;
            height: 44px;
            line-height: 44px;
            border-radius: 22px;
            background-color: #3062DE;
            font-size: 18px;
            color: #FFFFFF;
            font-weight: 600;
            margin: 16px auto 0;
            text-align: center;
        }
    }
}
.privacy_notice{
    width: 90%;
    margin: 10px auto 0;
    text-align: center;
    font-size: 12px;
    color: #999999;
    a{
        color: #3062DE;
        cursor: pointer;
        text-decoration: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/plugin_unit_login.vue